import React, { Component } from "react";
import { Column } from "@ant-design/plots";
import { AppRoutes } from "../../../AppRoutes";

class AdnColumn extends Component {
    shouldComponentUpdate(nextProps) {
        if (
            nextProps.employeeFollowUpEventsconfig.data !==
            this.props.employeeFollowUpEventsconfig.data
        ) {
            return true;
        } else {
            return false;
        }
    }

    render() {
        return (
            <Column
                {...this.props.employeeFollowUpEventsconfig}
                onEvent={(...args) => {
                    if (args[1].type == "plot:click" && args[1].data != null) {
                        let userName =
                            args[1].data.data && args[1].data.data.userName != "Not Done"
                                ? args[1].data.data.userName
                                : "";
                        let followUpEventYear = args[1].data.data.year;
                        let followUpEventMonth = args[1].data.data.month;
                        let followUpEventStatus = args[1].data.data.status;
                        if (userName == "Canceled/ Not Assigned") userName = "";
                        this.props.navigate(
                            AppRoutes.followUpEventList.createPathWithSearch(
                                userName,
                                followUpEventMonth,
                                followUpEventYear,
                                followUpEventStatus
                            )
                        );
                    }
                }}
            />
        );
    }
}

export default AdnColumn;
